import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    isLoadingRole: false,
    userInfo: [], //this info is of mayca db
    userInfoFromApi: [], //this is ours db
    showMFAModal: false,
    role: null,
    notMember: false
};

export const userAuthSlice = createSlice({
    name: "userAuth",
    initialState,
    reducers: {
        setIsLoading: (state, { payload } ) => {
            state.isLoading = payload
        },
        setIsLoadingRole: (state, { payload } ) => {
            state.isLoadingRole = payload
        },
        setUserManager: (state, { payload }) => {
            state.userInfo = payload;
        },
        setUserFromApi: (state, { payload }) => {
            state.userInfoFromApi = payload;
            state.role = payload.role
            state.showMFAModal = !payload.hasMfa
        },
        setShowMFAModal: (state, { payload }) => {
            state.showMFAModal = payload
        },
        setNotMember: (state, { payload }) => {
            state.notMember = payload
        }
    },
});
export const userAuthActions = userAuthSlice.actions;

export default userAuthSlice.reducer;
